import script from "./RegistroList.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroList.vue?vue&type=script&setup=true&lang=js"

import "./RegistroList.vue?vue&type=style&index=0&id=ab58a948&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab58a948"]])

export default __exports__